import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.25 20.75a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75V4.25A.75.75 0 0 0 21 3.5h-6A.75.75 0 1 0 15 5h5.25v15H15a.75.75 0 0 0-.75.75M3.97 11.97l3.75-3.75a.75.75 0 0 1 1.061 1.06l-2.47 2.47H15a.75.75 0 1 1 0 1.5H6.31l2.47 2.47a.75.75 0 1 1-1.061 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06"
    }, null, -1)
  ])))
}
export default { render: render }